import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";

import { ExampleWidget as ExampleWidgetImpl } from "@up/ui";
import Wrapper from "~/components/SliceWrapper";

export type ExampleWidgetProps =
  SliceComponentProps<Content.ExampleWidgetSlice>;

const ExampleWidget: FC<ExampleWidgetProps> = ({ slice }) => {
  return (
    // @ts-expect-error — SliceWrapper is an untyped JS component
    <Wrapper
      data-analytics-component="example-widget"
      slice={slice}
      verticalPadding={false}
    >
      <ExampleWidgetImpl slice={slice} />
    </Wrapper>
  );
};

export default ExampleWidget;
